/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ParticipantStatus } from './ParticipantStatus';
import {
    ParticipantStatusFromJSON,
    ParticipantStatusFromJSONTyped,
    ParticipantStatusToJSON,
    ParticipantStatusToJSONTyped,
} from './ParticipantStatus';
import type { ParticipantRelationship } from './ParticipantRelationship';
import {
    ParticipantRelationshipFromJSON,
    ParticipantRelationshipFromJSONTyped,
    ParticipantRelationshipToJSON,
    ParticipantRelationshipToJSONTyped,
} from './ParticipantRelationship';

/**
 * 
 * @export
 * @interface StaffParticipant
 */
export interface StaffParticipant {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    relationship: ParticipantRelationship | null;
    /**
     * 
     */
    email: string | null;
    /**
     * 
     */
    phone: string | null;
    /**
     * 
     */
    status: ParticipantStatus;
    /**
     * 
     */
    email_suppressed: boolean;
    /**
     * 
     */
    email_suppression_reason: string | null;
    /**
     * 
     */
    contact_confirmed_at: Date | null;
    /**
     * 
     */
    access_period_expires_at: Date | null;
    /**
     * 
     */
    access_revoked_at: Date | null;
    /**
     * 
     */
    access_active: boolean;
    /**
     * 
     */
    last_opened_at: Date | null;
    /**
     * 
     */
    unacknowledged_message_count: number;
}



/**
 * Check if a given object implements the StaffParticipant interface.
 */
export function instanceOfStaffParticipant(value: object): value is StaffParticipant {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('relationship' in value) || value['relationship'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('email_suppressed' in value) || value['email_suppressed'] === undefined) return false;
    if (!('email_suppression_reason' in value) || value['email_suppression_reason'] === undefined) return false;
    if (!('contact_confirmed_at' in value) || value['contact_confirmed_at'] === undefined) return false;
    if (!('access_period_expires_at' in value) || value['access_period_expires_at'] === undefined) return false;
    if (!('access_revoked_at' in value) || value['access_revoked_at'] === undefined) return false;
    if (!('access_active' in value) || value['access_active'] === undefined) return false;
    if (!('last_opened_at' in value) || value['last_opened_at'] === undefined) return false;
    if (!('unacknowledged_message_count' in value) || value['unacknowledged_message_count'] === undefined) return false;
    return true;
}

export function StaffParticipantFromJSON(json: any): StaffParticipant {
    return StaffParticipantFromJSONTyped(json, false);
}

export function StaffParticipantFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffParticipant {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
        'relationship': ParticipantRelationshipFromJSON(json['relationship']),
        'email': json['email'],
        'phone': json['phone'],
        'status': ParticipantStatusFromJSON(json['status']),
        'email_suppressed': json['email_suppressed'],
        'email_suppression_reason': json['email_suppression_reason'],
        'contact_confirmed_at': (json['contact_confirmed_at'] == null ? null : parseDateTime(json['contact_confirmed_at'])),
        'access_period_expires_at': (json['access_period_expires_at'] == null ? null : parseDateTime(json['access_period_expires_at'])),
        'access_revoked_at': (json['access_revoked_at'] == null ? null : parseDateTime(json['access_revoked_at'])),
        'access_active': json['access_active'],
        'last_opened_at': (json['last_opened_at'] == null ? null : parseDateTime(json['last_opened_at'])),
        'unacknowledged_message_count': json['unacknowledged_message_count'],
    };
}

export function StaffParticipantToJSON(json: any): StaffParticipant {
    return StaffParticipantToJSONTyped(json, false);
}

export function StaffParticipantToJSONTyped(value?: StaffParticipant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
        'relationship': ParticipantRelationshipToJSON(value['relationship']),
        'email': value['email'],
        'phone': value['phone'],
        'status': ParticipantStatusToJSON(value['status']),
        'email_suppressed': value['email_suppressed'],
        'email_suppression_reason': value['email_suppression_reason'],
        'contact_confirmed_at': value['contact_confirmed_at'] == null ? value['contact_confirmed_at'] : serializeDateTime(value['contact_confirmed_at']),
        'access_period_expires_at': value['access_period_expires_at'] == null ? value['access_period_expires_at'] : serializeDateTime(value['access_period_expires_at']),
        'access_revoked_at': value['access_revoked_at'] == null ? value['access_revoked_at'] : serializeDateTime(value['access_revoked_at']),
        'access_active': value['access_active'],
        'last_opened_at': value['last_opened_at'] == null ? value['last_opened_at'] : serializeDateTime(value['last_opened_at']),
        'unacknowledged_message_count': value['unacknowledged_message_count'],
    };
}

